import {AfterViewInit, Component, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {AuthService} from '../../../@core/services/auth.service';
import {CompanyResponse, UserEntityRelationWithoutUserDataResponse, UserResponse} from '../../models/response.module';
import {UserService} from '../../../@core/services/user.service';
import {CompanyService} from '../../services/company.service';
import {COR_COY_4} from '../../models/input.module';
import {StorageService} from '../../../@core/services/storage.service';
import {Subscription} from 'rxjs';

declare const KTMenu: any;
declare const bootstrap: any;

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.html',
  styleUrl: './header.css'
})
export class Header implements OnDestroy, AfterViewInit {
  isLoggedIn = false;
  userImage: string | null = null;
  isAuthenticated = false;
  user: UserEntityRelationWithoutUserDataResponse;
  userObj: UserResponse;
  companies: CompanyResponse[]
  superAdmin: boolean = false;
  private authSubscription: Subscription | undefined;

  @ViewChild('navbarCollapse') navbarCollapse: ElementRef;

  constructor(
    private autService: AuthService,
    private userService: UserService,
    private companyService: CompanyService,
    public storageService: StorageService,
    private authService: AuthService) {
  }

  ngOnInit() {
    // Subscribe to authentication state changes
    this.authSubscription = this.authService.isAuthenticated.subscribe((isAuth) => {
      this.isAuthenticated = isAuth;

      if (isAuth) {
        // Load user data when authenticated
        this.loadUserData();
      } else {
        // Clear user data when not authenticated
        this.userObj = null!;
        this.user = null!;
        this.superAdmin = false;
      }
    });
  }

  ngAfterViewInit() {
    // Re-initialize KT Menu components after view loads
    this.initializeMenus();
  }

  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  initializeMenus() {
    // Re-initialize all KT Menu instances
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.init();
        console.log('KT Menu initialized');
      }
    }, 100);
  }

  loadUserData() {
    this.userService.getUser().subscribe((data) => {
      this.userObj = data.data;
      console.log("User Obj in Header:", this.userObj)
      if (!this.userObj.profile_image_url) {
      }
      console.log(this.userObj.profile_image_url)
    });

    setTimeout(() => {
      this.userService.getUserEntityRelation().subscribe((data) => {
        this.user = data.find((relation) => relation.entity_id == this.storageService.getSelectedCompanyId())!;
      });
    }, 1000);

    let token = this.authService.getToken()
    if (token) {
      console.log("token:", token)
      for (const key in token.role_access) {
        if (token.role_access[key].includes('BWN-0')) {
          this.superAdmin = true;
          this.getAllCompanies()
          console.log('Super Admin');
          break;
        }
      }
    }
  }

  onLogin() {
    this.isLoggedIn = true;
    this.userImage = null; // replace with actual user profile image
  }

  getAllCompanies() {
    let payload: COR_COY_4 = {
      paginate: 0,
    }

    this.companyService.getAllCompanies(payload).subscribe((data) => {
      this.companies = data.data;
      console.log("Companies: ", this.companies)
      // Re-initialize menus after companies are loaded
      this.initializeMenus();
    })
  }


  onSignOut() {
    this.autService.logout()
  }

  closeMobileMenu() {
    if (this.navbarCollapse && window.innerWidth < 992) {
      const collapseElement = this.navbarCollapse.nativeElement;
      if (collapseElement.classList.contains('show')) {
        const bsCollapse = bootstrap.Collapse.getInstance(collapseElement) || new bootstrap.Collapse(collapseElement, { toggle: false });
        bsCollapse.hide();
      }
    }
  }
}
